module.exports = __webpack_public_path__ + "media/icons/trailhead-sprite/svg/symbols-4b78b1c926d8187119e8a218e7c51907.svg";